// LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, signOut, fetchUserAttributes } from 'aws-amplify/auth';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Paper
} from '@mui/material';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signOut(); 
      
     
      const { isSignedIn } = await signIn({ username, password });

      if (isSignedIn) {
        const userAttributes = await fetchUserAttributes();
        const email = userAttributes.email;

        if (email) {

          if (window.initializeChatbot) {
            window.initializeChatbot({
              userEmail: email,
              // You can add other attributes here too
              givenName: userAttributes.given_name,
              customerName: userAttributes.name
            });
          } else {
            console.error('Chatbot initialization function not found.');
          }

          console.log(`Sending email (${email}) to the API...`);
          
          const response = await fetch('https://6ofxduxpwc.execute-api.us-east-1.amazonaws.com/Prod/echo', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: email, attribute: userAttributes }),
          });

          if (!response.ok) {
            throw new Error('Failed to send user data to the API.');
          }

          console.log('Successfully sent email to the API.');
        
        } else {
            console.warn('User email attribute not found in Cognito.');
        }

        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message || 'An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={6} sx={{ padding: 4, mt: 10 }}>
        <Typography variant="h5" gutterBottom align="center">
          Sign in to Your Account
        </Typography>
        <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 2 }}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            required
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            required
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              py: 1.5,
              background: 'linear-gradient(45deg, #00695f, #26a69a)',
              color: 'white',
              fontWeight: 'bold',
              '&:hover': {
                background: 'linear-gradient(45deg, #004d40, #1de9b6)',
              }
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
          </Button>

          {error && (
            <Typography color="error" align="center" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </Box>
      </Paper>
    </Container>
  );
}

export default LoginPage;